import React from 'react';
import { Box, Button, Typography } from '@mui/material';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import {
  emptyStateBoxSx,
  emptyStateCreateButtonSx,
  emptyStateCreateIconSx,
  emptyStateHintSx,
  emptyStateIconBoxSx,
  emptyStateIconSx,
  emptyStateTitleSx,
} from '../Map/components/UserLotListsPanel/UserLotListsPanel.styles';

/** Variante `dense` (tarjetas de alto fijo, p. ej. «Precio vs. mercado»): ícono de 32 px. */
const denseBoxSx = { minHeight: 0, py: 0, gap: 0.75 };
const denseIconBoxSx = { width: 32, height: 32, p: '7px', mb: 0.25 };
const denseIconSx = {
  fontSize: 18, width: 18, height: 18, color: '#ABABAB',
};
const denseTitleSx = { fontSize: '13px', lineHeight: '16px' };
const denseHintSx = { fontSize: '12px', lineHeight: '16px' };

/**
 * Estado vacío de panel: ícono en un cuadrado, título, subtexto y CTA primario opcional
 * (patrón de Leads, reusado en Listas). Sin `onAction` no hay botón. `dense`: versión
 * mini (ícono 32 px, título 13 px, subtexto 12 px) para tarjetas chicas.
 */
const PanelEmptyState = ({
  icon: Icon,
  title,
  hint = null,
  actionLabel = null,
  onAction = null,
  /** Ícono del CTA (default «+» de crear); p. ej. `RefreshIcon` para «Reintentar». */
  actionIcon: ActionIcon = AddCircleOutlineIcon,
  testId = undefined,
  /** Ajustes del contenedor (p. ej. `minHeight`). */
  sx = null,
  dense = false,
}) => (
  <Box sx={{ ...emptyStateBoxSx, ...(dense ? denseBoxSx : null), ...sx }} data-testid={testId}>
    {Icon ? (
      <Box sx={dense ? { ...emptyStateIconBoxSx, ...denseIconBoxSx } : emptyStateIconBoxSx}>
        <Icon sx={dense ? { ...emptyStateIconSx, ...denseIconSx } : emptyStateIconSx} aria-hidden={dense || undefined} />
      </Box>
    ) : null}
    <Typography sx={dense ? { ...emptyStateTitleSx, ...denseTitleSx } : emptyStateTitleSx}>{title}</Typography>
    {hint ? <Typography sx={dense ? { ...emptyStateHintSx, ...denseHintSx } : emptyStateHintSx}>{hint}</Typography> : null}
    {actionLabel && onAction ? (
      <Button
        variant="contained"
        startIcon={ActionIcon ? <ActionIcon sx={emptyStateCreateIconSx} /> : null}
        onClick={onAction}
        sx={emptyStateCreateButtonSx}
      >
        {actionLabel}
      </Button>
    ) : null}
  </Box>
);

export default PanelEmptyState;
